module.exports = __webpack_public_path__ + "img/body-1.a00a1fab.jpg";